import AnimatedButton from "./button";

export default AnimatedButton